// Libs
import * as _ from 'lodash';

//Constants
import * as ACTIONS from './actionTypes';
import { DEFAULT_PAGE_SIZE } from './constants'

//Types
import { Dealer, DealerPhoneNumber, WebsiteProvider } from './types';
import { ActionEditDealerSearchQuery, ActionEditSelectedDealer, ActionGetDealerApiSuccess, ActionGetDealerByIdSuccess, ActionUpdateSelectedDealerByIdSuccess } from './actions';

export interface DealerState {
    dealers?: Dealer[]
    page: number,
    query: string,
    limit: number,
    lastPageSize?: number
    selectedDealer?: Dealer,
    error?:boolean,
    phoneNumbers?: DealerPhoneNumber[],
    industry?:string
    websiteProvider?: WebsiteProvider;
}

const defaultState: DealerState = {
    dealers: undefined,
    page: 0,
    query: "",
    limit: DEFAULT_PAGE_SIZE,
    error:false
};

type DealerAction = ActionGetDealerApiSuccess | ActionEditDealerSearchQuery | ActionEditSelectedDealer | ActionGetDealerByIdSuccess

function dealerReducer(state: DealerState = defaultState, action: DealerAction): DealerState {
    switch (action.type) {

        case ACTIONS.GET_DEALER_API_SUCCESS:
            {
                const { page } = (action as ActionGetDealerApiSuccess)
                const apiDealers = (action as ActionGetDealerApiSuccess).dealers
                const { dealers } = state;
                const newDealers = _.uniqBy([...(dealers ?? []), ...apiDealers], 'id');
                return {
                    ...state,
                    dealers: newDealers,
                    page: page || 0,
                    lastPageSize: apiDealers?.length,
                    error:false
                }
            }
        case ACTIONS.GET_DEALER_BY_ID_API_SUCCESS:
            {
                const { dealer } = (action as ActionGetDealerByIdSuccess)
                const newDealers = _.uniqBy([...(state.dealers ?? []), ...[dealer]], 'id');
                return {
                    ...state,
                    dealers: newDealers,
                    error:false
                }
            }
        case ACTIONS.DEALERS_LOAD_MORE: {
            return {
                ...state,
                page: state.page + 1
            }
        }
        case ACTIONS.EDIT_DEALER_SEARCH_QUERY: {
            const { query } = action as ActionEditDealerSearchQuery;
            return {
                ...state,
                dealers: query === state.query ? state.dealers : [],
                page: 0,
                query,
                error:false
            }
        }
        case ACTIONS.EDIT_SELECTED_DEALER: {
            const { dealer } = action as ActionEditSelectedDealer;
            return {
                ...state,
                selectedDealer: dealer,
                industry:dealer?.industry,
                websiteProvider: dealer?.websiteProvider,
                error:false
            }
        }
        case ACTIONS.UPDATE_SELECTED_DEALER_SUCCESS:{
            const { dealer } = action as ActionUpdateSelectedDealerByIdSuccess;
            return {
                ...state,                       
                phoneNumbers: dealer.phoneNumbers,         
                industry:dealer.industry,      
                websiteProvider: dealer.websiteProvider,
                error:false
            }
        }
        case ACTIONS.GET_DEALER_BY_ID_API_ERROR:{
            return{
                ...state,
                error:true
            }

        }
    }
    return {
        ...state
    }
}

export default dealerReducer;